module.exports = __webpack_public_path__ + "assets/5c482ee8d81cf1b3c67cfb082d6aa5b5.gif";